<script lang="ts">
  import { onMount } from "svelte";
  import { Picker } from "emoji-mart";
  import styles from "./styles";

  export let onClick = (emoticon: any) => {};
  // Using export const for props used for external reference only
  export const position = "right";

  let emoticonsElement: HTMLDivElement;

  const s = styles({});

  onMount(() => {
    const picker = new Picker({
      previewPosition: "none",
      onEmojiSelect: onClick,
    });
    // The emoji-mart Picker constructs an actual DOM element
    // We need to handle this as a special case since the type isn't properly exported
    emoticonsElement.appendChild(picker as unknown as Node);
  });
</script>

<div
  id="emoticons"
  class={s.emoticonWrapper}
  bind:this={emoticonsElement}
></div>
